module.exports = __webpack_public_path__ + "static/media/ecoswitch_icon_text.06458051.png";